<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Course Outcomes</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Course Outcomes</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="about-institute ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <iframe src="https://drive.google.com/file/d/1GbupEXSRRrGMWntEreJkOUlWTnlRPKYV/preview?usp=sharing" width="100%"
          height="800"></iframe>
      </div>
    </div>
  </div>
</section>
